import styled, {css} from 'styled-components'
import {DialogBody, DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'

export const StyledSiarExportDetailDialogBody = styled(DialogBody)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 3}px;
        padding-top: ${spacing * 2}px;
    `
)

export const StyledSiarExportDetailHeading = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing}px;
    `
)

export const StyledSiarExportDetailSubheading = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        ${typography.textSm};
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: ${spacing}px;
        color: ${palette.neutral[600]};
    `
)

export const StyledSiarExportDetailMetaRow = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        ${typography.textSm};
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: ${spacing * 2}px;
        padding: ${spacing * 2}px ${spacing * 3}px;
        border-radius: 8px;
        background: ${palette.neutral[50]};
        border: 1px solid ${palette.neutral[200]};
        color: ${palette.neutral[700]};
    `
)

export const StyledSiarExportDetailMetaLeft = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
    `
)

export const StyledSiarExportDetailActionsRow = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
    `
)

export const StyledSiarExportDetailSelectionInfo = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        ${typography.textSm};
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        color: ${palette.neutral[700]};
    `
)

export const StyledSiarExportDetailTextButton = styled.button(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        background: transparent;
        border: none;
        cursor: pointer;
        color: ${palette.primary[700]};
        font-weight: 600;

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

        &:not(:disabled):hover {
            text-decoration: underline;
        }
    `
)

export const StyledSiarExportDetailActionsSpacer = styled.div`
    flex: 1;
`

export const StyledSiarExportDetailTransmissionForm = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        ${typography.textSm};
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        padding: ${spacing * 2}px ${spacing * 3}px;
        border-radius: 8px;
        background: ${palette.orange[50]};
        border: 1px solid ${palette.orange[200]};
        color: ${palette.orange[900]};
    `
)

export const StyledSiarExportDetailTransmissionMessage = styled.span(
    ({theme: {spacing}}) => css`
        flex: 1;
        display: inline-flex;
        align-items: center;
        gap: ${spacing}px;
    `
)

export const StyledSiarExportDetailFooter = styled(DialogFooter)(
    ({theme: {spacing}}) => css`
        display: flex;
        justify-content: flex-end;
        gap: ${spacing * 2}px;
    `
)
